<template>
  <div>
    <base-header id="status-header" type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <div class="row">
        <div class="col-xl-3 col-lg-6" @click="showTable('255', $event)">
          <stats-card
            id="totalArticle"
            title="Total Articles"
            type="gradient-red"
            :sub-title="totalArticle"
            class="mb-4 mb-xl-0 bg-yellow"
          ></stats-card>
        </div>
        <div class="col-xl-3 col-lg-6" @click="showTable('1', $event)">
          <stats-card
            id="totalPublishedArticle"
            title="Published"
            type="gradient-orange"
            :sub-title="totalPublishedArticle"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="col-xl-3 col-lg-6" @click="showTable('2', $event)">
          <stats-card
            id="totalUnpublishedArticle"
            title="Unpublished"
            type="gradient-orange"
            :sub-title="totalUnpublishedArticle"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="col-xl-3 col-lg-6" @click="showTable('0', $event)">
          <stats-card
            id="totalDraftArticle"
            title="Draft"
            type="gradient-orange"
            :sub-title="totalDraftArticle"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <articles-table :status="tableArticleStatus"></articles-table>
        </div>
      </div>
    </div>

    <div class="container-fluid mt--7" style="display: none;">
      <div class="row">
        <div class="col"></div>
      </div>
    </div>
  </div>
</template>
<script>
import ArticlesTable from "./Tables/ArticlesTable";
import EventBus from "./../event-bus";
export default {
  name: "tables",
  components: {
    ArticlesTable
  },
  data() {
    return {
      totalArticle: "0",
      totalPublishedArticle: "0",
      totalUnpublishedArticle: "0",
      totalDraftArticle: "0",
      tableArticleStatus: "255"
    };
  },
  mounted() {
    EventBus.$on("getTotalArticles", () => {
      this.getTotalArticles();
    });
    EventBus.$on("getTotalPublishedArticles", () => {
      this.getTotalPublishedArticles();
    });
    EventBus.$on("getTotalUnpublishedArticles", () => {
      this.getTotalUnpublishedArticles();
    });
    EventBus.$on("getTotalDraftArticles", () => {
      this.getTotalDraftArticles();
    });
    this.getTotalArticles();
    this.getTotalPublishedArticles();
    this.getTotalUnpublishedArticles();
    this.getTotalDraftArticles();

    $("#totalArticle .card-body .row .col .card-title").removeClass(
      "text-muted"
    );
    $("#totalArticle .card-body .row .col .card-title").addClass("text-body");
    $("#totalPublishedArticle .card-body .row .col .card-title").removeClass(
      "text-muted"
    );
    $("#totalPublishedArticle .card-body .row .col .card-title").addClass(
      "text-success"
    );
    $("#totalUnpublishedArticle .card-body .row .col .card-title").removeClass(
      "text-muted"
    );
    $("#totalUnpublishedArticle .card-body .row .col .card-title").addClass(
      "text-danger"
    );
    $("#totalDraftArticle .card-body .row .col .card-title").removeClass(
      "text-muted"
    );
    $("#totalDraftArticle .card-body .row .col .card-title").addClass(
      "text-muted"
    );
  },
  methods: {
    showTable(status, event) {
      this.tableArticleStatus = status;
      this.$router.push({ query: { page: 1 } });

      var statusCards = $(event.target)
        .closest("#status-header")
        .find("div.card");
      for (var i = 0; i < statusCards.length; i++) {
        $(statusCards[i]).removeClass("bg-yellow");
      }

      $(event.target)
        .closest("div.card")
        .addClass("bg-yellow");
    },

    getTotalArticles() {
      this.$store
        .dispatch("fetchTotalArticles", {
          status: "255"
        })
        .then(response => {
          this.totalArticle = response.data.total.toString();
        });
    },

    getTotalPublishedArticles() {
      this.$store
        .dispatch("fetchTotalArticles", {
          status: "1"
        })
        .then(response => {
          this.totalPublishedArticle = response.data.total.toString();
        });
    },

    getTotalUnpublishedArticles() {
      this.$store
        .dispatch("fetchTotalArticles", {
          status: "2"
        })
        .then(response => {
          this.totalUnpublishedArticle = response.data.total.toString();
        });
    },

    getTotalDraftArticles() {
      this.$store
        .dispatch("fetchTotalArticles", {
          status: "0"
        })
        .then(response => {
          this.totalDraftArticle = response.data.total.toString();
        });
    }
  }
};
</script>
<style></style>
